import {addEventListener} from 'handle-events';

/**
 * @private
 */
let promise;

/**
 * @public
 *
 * Resolves a promise when the DOM has been loaded and is ready.
 * It happens when the HTML document has been completely loaded and parsed,
 * without waiting for stylesheets, images, and subframes to finish loading.
 *
 * @return {Promise}
 */
export default function readyDOM() {
  if (promise) return promise;

  if (document.readyState !== 'loading') {
    promise = Promise.resolve();
  } else {
    promise = new Promise((resolve) => {
      addEventListener(document, 'DOMContentLoaded.readyDOM', () => {
        resolve();
      });
    });
  }

  return promise;
}
